(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('ThirdPartyAppOverviewController', ['ItemTableService', 'apps', ThirdPartyAppOverviewControllerFn]);

    /* controlle for main third-party-app */
    function ThirdPartyAppOverviewControllerFn(ItemTableService, apps) {
        var vm = this;

        // table service data
        vm.overview = null;

        activate();

        /* activation work */
        function activate() {
            vm.overview = ItemTableService;
            // init table-item list
            vm.overview.init(apps);
        }
    }
})();